export const AssessmentValue = {
  INCOMPLETE: 'Arrhythmic examination not completed',
  NO_ANOMALY: 'Normal Sinus Rhythm',
  LOW_AMPLITUDE:
    'The amplitude of the electrocardiogram is very low, please make sure the contact surface is clean and try again',
  SIGNIFICANT_NOISE:
    'There is obvious noise in the electrocardiogram signal, please make sure the device is not held too tightly and try again',
  UNSTABLE_SIGNAL: 'The electrocardiogram signal is unstable, please keep still and try again',
  NOT_ENOUGH_DATA: 'There is not enough data, please make sure you keep still and try again',
  BRADYCARDIA: 'Bradycardia detected',
  AFIB: 'Atrial Fibrillation detected',
  TACHYCARDIA: 'Tachycardia detected',
  ABNORMALITY: 'Abnormalities Detected. However, bradycardia, atrial fibrillation, or tachycardia cannot be confirmed',
} as const;
